<template>
  <div class="network-edit-page scrollable">
    <div class="page-header">
      <h1>{{ isEditMode ? 'Edit Proxy' : 'Create Proxy' }}</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'proxy-table' }">
          Proxy Table
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ isEditMode ? 'Edit Proxy' : 'Create Proxy' }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="edit-form">
      <el-form
        :model="formData"
        status-icon
        :rules="rulesValidate"
        ref="proxyForm"
        label-width="135px"
        class="demo-ruleForm"
      >

        <el-form-item label="Username" prop="username">
          <el-input
            type="text"
            v-model="formData.username"
            autocomplete="off"
            placeholder="Proxy username"
          ></el-input>
        </el-form-item>

        <el-form-item label="Password" prop="password">
          <el-input
            type="password"
            v-model="formData.password"
            autocomplete="off"
            placeholder="Proxy password"
          ></el-input>
        </el-form-item>

        <el-form-item label="IP Address" prop="ip">
          <el-input
            type="text"
            v-model="formData.ip"
            autocomplete="off"
            placeholder="192.168.1.1"
          ></el-input>
        </el-form-item>

        <el-form-item label="Port" prop="port">
          <el-input
            type="number"
            v-model.number="formData.port"
            autocomplete="off"
            placeholder="8080"
          ></el-input>
        </el-form-item>

        <el-form-item label="City" prop="city">
          <el-input
            type="text"
            v-model="formData.city"
            autocomplete="off"
            placeholder="New York"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('proxyForm')"
            :loading="submitting"
          >
            {{ isEditMode ? 'Update' : 'Create' }}
          </el-button>
          <el-button @click="goBack">
            Cancel
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getProxyPaid, createProxyPaid, updateProxyPaid } from '@/api/proxyApi'

export default {
  name: 'ProxyTableEdit',
  data() {
    return {
      submitting: false,
      formData: {
        username: '',
        password: '',
        ip: '',
        port: null,
        city: '',
      },

      rulesValidate: {
        username: [{required: true, message: 'Username is required', trigger: 'blur'}],
        password: [{required: true, message: 'Password is required', trigger: 'blur'}],
        ip: [
          {required: true, message: 'IP address is required', trigger: 'blur'},
          {pattern: /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/, message: 'Please enter a valid IP address', trigger: 'blur'}
        ],
        port: [
          {required: true, message: 'Port is required', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              if (value === '' || value === null || value === undefined) {
                callback(new Error('Port is required'));
                return;
              }

              const portNum = Number(value);
              if (isNaN(portNum) || !Number.isInteger(portNum)) {
                callback(new Error('Port must be a valid number'));
              } else if (portNum < 1 || portNum > 65535) {
                callback(new Error('Port must be between 1 and 65535'));
              } else {
                callback();
              }
            },
            trigger: ['blur', 'change']
          }
        ]
      },
    }
  },
  computed: {
    isEditMode() {
      return this.$route.name === 'proxy-edit' && this.$route.params.id
    }
  },
  async mounted() {
    if (this.isEditMode) {
      await this.loadProxyData()
    }
  },
  methods: {
    async loadProxyData() {
      try {
        const response = await getProxyPaid(this.$route.params.id)
        this.formData = { ...response.data }
      } catch (error) {
        console.error('Error loading proxy data:', error)
        this.$notify.error({
          title: 'Error',
          message: 'Failed to load proxy data'
        })
        this.goBack()
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.submitting = true
          try {
            const submitData = {
              ...this.formData,
              port: parseInt(this.formData.port)
            }

            if (this.isEditMode) {
              await updateProxyPaid(this.$route.params.id, submitData)
              this.$notify.success({
                title: 'Success',
                message: 'Proxy updated successfully'
              })
            } else {
              await createProxyPaid(submitData)
              this.$notify.success({
                title: 'Success',
                message: 'Proxy created successfully'
              })
            }
            this.goBack()
          } catch (error) {
            console.error('Error saving proxy:', error)
            this.$notify.error({
              title: 'Error',
              message: `Failed to ${this.isEditMode ? 'update' : 'create'} proxy`
            })
          } finally {
            this.submitting = false
          }
        } else {
          return false
        }
      })
    },

    goBack() {
      this.$router.push({ name: 'proxy-table' })
    }
  }
}
</script>

<style scoped>
.network-edit-page {
  padding: 20px;
}

.edit-form {
  max-width: 600px;
  margin: 0 auto;
}

.demo-ruleForm {
  background: white;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
</style>
